import styled from "styled-components";

export const ContentOptionForChat = styled.div(() => ({
    display: "flex",
    padding: "20px 0px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "4px",
    alignSelf: "stretch",
    maxWidth: "436px",
}))

export const TitleOptionForChat = styled.h3(({theme}) => ({
    color: theme.color.brandPrimary.light,
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "160%",
}))

export const DescriptionOptionForChat = styled.p(({theme}) => ({
    color: theme.color.neutral["03"],
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
}))

export const ButtonOptionForChat = styled.button(({theme}) => ({
    display: "flex",
    padding: "8px 24px",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "500px",
    border: "1px solid #005FC8",
    background: "transparent",
    cursor: "pointer",
    width: "125px",
    [theme.breakpoint.lg()]: {
        width: "auto",
    }
}))

export const TextButtonOptionForChat = styled.p(({theme}) => ({
    color: theme.color.brandPrimary.light,
    textAlign: "center",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
}))

export const OptionDivider = styled.div(() => ({
    width: "100%",
    height: "1px",
    display: "flex",
    border: "1px solid #D1DBE3",
    flexDirection: "column",
}))

export const ContentButton = styled.div(({theme}) => ({
    display: "flex",
    width: "100%",
    marginTop: "16px",
    justifyContent: "center",
    [theme.breakpoint.lg()]: {
        width: "auto",
    }
}))